'use client'

;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:offsoo-landing":true});}catch(e){}}();import { usePathname } from 'next/navigation'
import { useEffect, useRef } from 'react'

import { firePixelPageview } from '@/lib/analytics/pixels'

/**
 * Fires the browser ad-pixel PageView on client-side route changes, so Meta, TikTok and Google build
 * remarketing audiences across the whole site rather than only its entry page.
 *
 * The first render is skipped on purpose: each pixel's bootstrap snippet already recorded the
 * pageview for the load itself, and that is the one thing that fires reliably before hydration. Bing
 * UET tracks SPA navigation on its own and needs nothing here.
 *
 * No-op unless pixels are enabled.
 */
export function PixelPageviews() {
  const pathname = usePathname()
  const isFirst = useRef(true)

  useEffect(() => {
    if (isFirst.current) {
      isFirst.current = false

      return
    }

    firePixelPageview()
  }, [pathname])

  return null
}
